<section class="section py-6">
  <div class="columns">
    <div class="column header-title-page">
      <h2 class="title-header">Productos</h2>
      <button class="button is-primary" (click)="openModal()">Nuevo producto</button>
    </div>
  </div>
  <div class="columns">
    <div class="column is-6">
      <div class="field">
        <label class="label">Buscar</label>
        <p class="control has-icons-left">
          <input class="search-bar input" type="text" placeholder="Buscar..."[(ngModel)]="filters.search.value"
          (keyup.enter)="onFilter()">
          <span class="icon is-left">
            <fa-icon class="icon-search" [icon]="faMagnifyingGlass"></fa-icon>
          </span>
        </p>
      </div>
    </div>
  </div>
</section>
<section class="section py-1">
  <div class="columns has-background-white">
    <div class="column">
      <div class="columns">
        <div class="column p-5">
          @if(products) {
          <div class="table-products">
            <app-generic-table [columnsHeader]="COLUMNS_HEADER" [dataTable]="productsFiltered" (onSelectRow)="openModal($event)"
              (onDeleteItem)="delete($event)"></app-generic-table>
          </div>
          }

        </div>
      </div>
    </div>
  </div>
</section>
<div class="modal" [ngClass]="{'is-active': isModalActive }">
  <div class="modal-background"></div>
  <div class="modal-card">
    <form [formGroup]="form" (ngSubmit)="onSave()">
      <header class="modal-card-head">
        @if(isCreating) {
        <p class="modal-card-title">Nuevo producto</p>
        }@else {
        <p class="modal-card-title">Producto: {{ form.value.id }}</p>
        }
        <button type="button" class="delete" aria-label="close" (click)="closeModal()"></button>
      </header>
      <section class="modal-card-body">
        <div class="columns">
          <div class="column">
            @if(isCreating) {
            <div class="field">
              <label class="label">Grad</label>
              <div class="control">
                <input class="input" type="text" placeholder="Id" formControlName="id">
              </div>
            </div>
            }
            <div class="field">
              <label class="label">Activo</label>
              <input id="isActiveSwitch" type="checkbox" name="isActiveSwitch" class="switch is-rounded"
                formControlName="active">
              <label for="isActiveSwitch"></label>
            </div>
            <div class="field">
              <label class="label">Producto</label>
              <div class="control">
                <input class="input" type="text" placeholder="Descripción" formControlName="description">
              </div>
            </div>
            <div class="field">
              <label class="label">Naturaleza del producto</label>
              <div class="control">
                <div class="select is-fullwidth">
                  <select formControlName="product_nature">
                    <option *ngFor="let nature of productNatureTypes" [ngValue]="nature">
                      {{ nature }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <!-- <div class="field">
              <label class="label">Tiempo de producción</label>
              <div class="control">
                <input class="input" type="text" placeholder="Tiempo" formControlName="production_time">
              </div>
            </div>
            <div class="field">
              <label class="label">Tiempo de calidad</label>
              <div class="control">
                <input class="input" type="text" placeholder="Tiempo" formControlName="quality_time">
              </div>
            </div>
            <div class="field">
              <label class="label">Hora de inicio</label>
              <div class="control">
                <input class="input" type="number" placeholder="Hora" formControlName="start_time">
              </div>
            </div> -->
          </div>
        </div>
      </section>
      <footer class="modal-card-foot is-justify-content-space-between">
        <button type="button" class="button" (click)="closeModal()">Cancelar</button>
        <button type="submit" class="button is-primary" [disabled]="!form.valid">
          @if(isLoading) {
          <fa-icon [icon]="faSpinner"></fa-icon>
          }@else {
          <span>Guardar</span>
          }
        </button>
      </footer>
    </form>
  </div>
</div>